// extracted by mini-css-extract-plugin
export default {"DefaultDays":"default-days_DefaultDays__LXgLJ","DefaultDaysButton":"default-days_DefaultDaysButton__sPx+k","Separator":"default-days_Separator__mF+yo"};